<template>
    <a-card :title="$t('login.title')" class="panel-login">
        <a-form-model ref="form" :model="formdata" :rules="rules">
            <a-form-model-item prop="username">
                <a-input v-model="formdata.username" type="text" autocomplete="off" :placeholder="$t('login.account')">
                    <a-icon slot="prefix" type="user" style="color: rgba(0, 0, 0, 0.25)" />
                </a-input>
            </a-form-model-item>
            <a-form-model-item prop="password">
                <a-input-password v-model="formdata.password" autocomplete="off" :placeholder="$t('login.password')">
                    <a-icon slot="prefix" type="lock" style="color: rgba(0, 0, 0, 0.25)" />
                </a-input-password>
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="onSubmit" block>{{ $t('login.button') }}</a-button>
            </a-form-model-item>
        </a-form-model>
    </a-card>
</template>
<script>
import { setCookie } from '@/utils'
export default {
    data() {
        return {
            formdata: {
                username: "",
                password: "",
            },
            rules: {
                username: [{
                    required: true,
                    message: this.$t("login.account_error"),
                    trigger: "blur",
                }, ],
                password: [{
                    required: true,
                    message: this.$t("login.password_error"),
                    trigger: "blur",
                }, ],
            },
        };
    },
    methods: {
        onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    const response = await this.$api.post(
                        "/login",
                        this.formdata
                    );
                    console.info("response", response);
                    if (
                        response &&
                        response.code == 200 &&
                        response.data.token && [2, 9].includes(response.data.type)
                    ) {
                        const { token, ...minfo } = response.data;
                        setCookie('token', token)
                        this.$storage.set("token", token);
                        this.$storage.set("minfo", minfo);
                        this.$store.dispatch("setToken", token);
                        location.replace(location.pathname);
                    } else {
                        this.$message.error(response.msg);
                    }
                }
            });
        },
    },
};
</script>
<style lang="less">
.panel-login {
    margin: 40px auto;
    width: 360px;
    max-width: 100%;
}

.form-meta {
    text-align: right;
}
</style>